/* eslint-disable no-console */
import { QueryClient } from '@tanstack/react-query'

import {
  createFlagInstance,
  getOptimizelyOverrides,
} from '@surglogs-app/feature-flags'
import { isProductionApp } from '@surglogs-app/util'

import * as hooks from './app/bootstrap'
import { config } from './app/config'
import { boot } from './app/configure'
import { createAuthProvider } from './containers/auth'
import { createClinicProvider } from './containers/clinic'
import { history } from './setupHistory'
import { signInCookieSetter } from './signInCookieSetter'

const datafile = window.__DATAFILE__
if (!datafile) {
  console.warn(
    '[optimizely] invalid datafile for optimizely given, datafile:',
    datafile,
    ', fallback to loading via sdk key',
    process.env.REACT_APP_OPTIMIZELY_KEY,
  )
}

// Check for test environments (Cypress or Playwright)
const isTestEnvironment =
  window.Cypress || window.Playwright || process.env.NODE_ENV === 'test'

const featureFlagsInstance = createFlagInstance({
  datafile,
  /**
   * @NOTE
   * dont pass optimizely key for test environments -> we don't want Optimizely to refresh in tests
   * this should improve stability of optimizely behavior in tests (mainly locally)
   */
  sdkKey: isTestEnvironment ? undefined : process.env.REACT_APP_OPTIMIZELY_KEY,
  appVersion: config.appVersion ?? 'v0.0.1',
  ...(!isProductionApp() ? { forcedDecisions: getOptimizelyOverrides() } : {}),
})

const auth = createAuthProvider()
const clinicContextStoreInstance = createClinicProvider(auth)
auth.tokenStore.onChange(signInCookieSetter)

if (
  process.env.NODE_ENV === 'development' ||
  window.Cypress ||
  window.Playwright
) {
  // @ts-ignore
  window.$auth = auth
  // @ts-ignore
  window.$optimizely = featureFlagsInstance // for debugging and cypress tests
}

if (window.Cypress) {
  // NOTE: this is only for Cypress, not production code
  window.postMessage('$beforeMount', '*')

  /**
   * THIS is a "hacky" way how to fix flaky tests in cypress caused by loading fonts
   *
   * We will set Helvetica font for everything, which is available everywhere without async load
   */
  const style = document.createElement('style')
  style.appendChild(
    document.createTextNode(`*,
      body,
      html {
        font-family: 'Helvetica', sans-serif !important;
      }`),
  )
  document.head.appendChild(style)
}

const queryClient = new QueryClient()
boot(hooks, config, {
  history,
  auth,
  featureFlagsInstance,
  queryClient,
  clinicContextStoreInstance,
})

if (window.Cypress) {
  // NOTE: this is only for Cypress, not production code
  window.postMessage('$afterMount', '*')
}

console.log('App file version:', config.appVersion)
